import SingleFeatureWithImage from "@components/StrapiComponents/SingleFeatureWithImage";
import TileWrapper from "@components/StrapiComponents/TileWrapper";
import TimedFeatureList from "@components/StrapiComponents/TimedFeatureList";
import HeroBanner from "@components/common/HeroBanner";
import { HeroBannerPropsModel } from "@models/hero-banner";
import { ProductSearchDynamicZones } from "@models/product-search";
import { StrapiComponentTypes } from "@models/strapi-component";
import { SingleFeatureWithImageDynamicModel } from "@models/strapi-components/single-feature-with-image";
import { TileWrapperDynamicZoneModel } from "@models/strapi-components/tile-wrapper";
import { HeadFC, PageProps, graphql } from "gatsby";
import React from "react";
import { ImageWrapperDynamicZoneModel } from "@models/strapi-components/image-wrapper";
import ImageWrapper from "@components/StrapiComponents/ImageWrapper";
import Testimonials from "@components/StrapiComponents/Testimonial";
import { TestimonialsDynamicZoneModel } from "@models/strapi-components/testimonials";
import { LastScrollCTADynamicZoneModel } from "@models/strapi-components/last-scroll-cta";
import LastScrollCTA from "@components/StrapiComponents/LastScrollCTA";
import { FeatureStatsDynamicZoneModel } from "@models/strapi-components/feature-stats";
import FeatureStats from "@components/StrapiComponents/FeatureStats";
import { TreeWithThreeTilesDynamicZoneModel } from "@models/strapi-components/tree-with-three-tiles";
import TreeWithThreeTiles from "@components/StrapiComponents/TreeWithThreeTiles";
import FaqComponent from "@components/StrapiComponents/FAQs";
import { FaqDynamicZoneModel } from "@models/strapi-components/faq-dynamic-zone";
import { NavigationResponseModel } from "@models/layout";
import SEO from "@components/common/Layout/SEO";
import { SeoDataModel } from "@models/seo";
import { StepsDynamicZoneModel } from "@models/strapi-components/steps";
import Steps from "@components/StrapiComponents/Steps";
import { CardWrapperDynamicZoneModel } from "@models/strapi-components/card-wrapper";
import CardWrapper from "@components/StrapiComponents/CardWrapper";
import Layout from "@components/common/Layout";
import { TimedFeatureDynamicZoneModel } from "@models/strapi-components/timed-feature-list";
import { ThreePointsHighLighterDynamicZoneModel } from "@models/strapi-components/three-points";
import ThreePointHighlighter from "@components/StrapiComponents/ThreePointHighlighter";
import { TimelineDynamicZoneModel } from "@models/strapi-components/timeline";
import { TimeLine } from "@components/StrapiComponents/TimeLine";

export interface PageContextModel {
  slug: string;
  id: string;
}
export interface PageDataModel {
  strapiProductSearch: {
    title: string;
    seo: SeoDataModel;
    topBanner: HeroBannerPropsModel;
    dynamicZoneComponents: ProductSearchDynamicZones[];
    darkTheme: boolean;
  };
  navigation: NavigationResponseModel;
}

const ProductSearchPage = (
  props: PageProps<PageDataModel, PageContextModel>
) => {
  const { path, data } = props;
  const { strapiProductSearch, navigation } = data ?? {};
  const {
    topBanner: heroBanner,
    dynamicZoneComponents,
    darkTheme,
  } = strapiProductSearch;

  const renderTimedFeatures = (componentData: TimedFeatureDynamicZoneModel) => (
    <div>
      <TimedFeatureList componentData={componentData} />
    </div>
  );

  const renderSingleFeatureWithImage = (
    componentData: SingleFeatureWithImageDynamicModel
  ) => (
    <div>
      <SingleFeatureWithImage componentData={componentData} />
    </div>
  );

  const renderTileWrapper = (componentData: TileWrapperDynamicZoneModel) => (
    <div>
      <TileWrapper componentData={componentData} />
    </div>
  );

  const renderImageWrapper = (componentData: ImageWrapperDynamicZoneModel) => (
    <div>
      <ImageWrapper componentData={componentData} />
    </div>
  );
  const renderTesimonials = (componentData: TestimonialsDynamicZoneModel) => (
    <div>
      <Testimonials componentData={componentData} />
    </div>
  );

  const renderLastScrollCTA = (
    componentData: LastScrollCTADynamicZoneModel
  ) => (
    <div>
      <LastScrollCTA componentData={componentData} />
    </div>
  );

  const renderFeatureStats = (componentData: FeatureStatsDynamicZoneModel) => (
    <div>
      <FeatureStats componentData={componentData} />
    </div>
  );

  const renderTreeWithThreeTiles = (
    componentData: TreeWithThreeTilesDynamicZoneModel
  ) => (
    <div>
      <TreeWithThreeTiles componentData={componentData} />
    </div>
  );

  const renderFaqs = (componentData: FaqDynamicZoneModel) => (
    <div>
      <FaqComponent componentData={componentData} />
    </div>
  );

  const renderSteps = (componentData: StepsDynamicZoneModel) => (
    <div>
      <Steps componentData={componentData} />
    </div>
  );
  const renderCardWrapper = (componentData: CardWrapperDynamicZoneModel) => (
    <div>
      <CardWrapper componentData={componentData} />
    </div>
  );
  const renderThreePointHighlighter = (
    componentData: ThreePointsHighLighterDynamicZoneModel
  ) => (
    <div>
      <ThreePointHighlighter componentData={componentData} />
    </div>
  );
  const renderTimelineWrapper = (componentData: TimelineDynamicZoneModel) => (
    <div>
      <TimeLine componentData={componentData} />
    </div>
  );

  const renderDynamicZone = (dynamicZone: ProductSearchDynamicZones) => {
    const { strapi_component: strapiComponent } = dynamicZone;
    let renderComponent = <></>;
    switch (strapiComponent) {
      case StrapiComponentTypes.TimedFeatureList:
        renderComponent = renderTimedFeatures(
          dynamicZone as TimedFeatureDynamicZoneModel
        );
        break;
      case StrapiComponentTypes.SingleFeatureWithImage:
        renderComponent = renderSingleFeatureWithImage(
          dynamicZone as SingleFeatureWithImageDynamicModel
        );
        break;
      case StrapiComponentTypes.TileWrapper:
        renderComponent = renderTileWrapper(
          dynamicZone as TileWrapperDynamicZoneModel
        );
        break;
      case StrapiComponentTypes.ImageWrapper:
        renderComponent = renderImageWrapper(
          dynamicZone as ImageWrapperDynamicZoneModel
        );
        break;
      case StrapiComponentTypes.TestimonialSlider:
        renderComponent = renderTesimonials(
          dynamicZone as TestimonialsDynamicZoneModel
        );
        break;
      case StrapiComponentTypes.LastScrollCTA:
        renderComponent = renderLastScrollCTA(
          dynamicZone as LastScrollCTADynamicZoneModel
        );
        break;

      case StrapiComponentTypes.FeatureStats:
        renderComponent = renderFeatureStats(
          dynamicZone as FeatureStatsDynamicZoneModel
        );
        break;
      case StrapiComponentTypes.TreeWithThreeTiles:
        renderComponent = renderTreeWithThreeTiles(
          dynamicZone as TreeWithThreeTilesDynamicZoneModel
        );
        break;
      case StrapiComponentTypes.FAQ:
        renderComponent = renderFaqs(dynamicZone as FaqDynamicZoneModel);
        break;
      case StrapiComponentTypes.Steps:
        renderComponent = renderSteps(dynamicZone as StepsDynamicZoneModel);
        break;
      case StrapiComponentTypes.CardWrapper:
        renderComponent = renderCardWrapper(
          dynamicZone as CardWrapperDynamicZoneModel
        );
        break;
      case StrapiComponentTypes.ThreePointHighLighter:
        renderComponent = renderThreePointHighlighter(
          dynamicZone as ThreePointsHighLighterDynamicZoneModel
        );
        break;
      case StrapiComponentTypes.Timeline:
        renderComponent = renderTimelineWrapper(
          dynamicZone as TimelineDynamicZoneModel
        );
        break;
      default:
        break;
    }
    return renderComponent;
  };

  return (
    <Layout darkTheme={darkTheme}>
      <HeroBanner
        {...heroBanner}
        path={path}
        appendToPath="Product"
        secondaryNav={navigation}
      />
      {dynamicZoneComponents?.map((dynamicZone) => {
        const { id } = dynamicZone;
        return <div key={id}>{renderDynamicZone(dynamicZone)}</div>;
      })}
    </Layout>
  );
};

export const query = graphql`
  query productSearch($id: String) {
    navigation(slug: { eq: "search" }) {
      id
      items {
        data {
          id
          attributes {
            order
            title
            url
            target
            # border_left
            border_bottom
            type_of_menu
            updatedAt
            children {
              data {
                id
                attributes {
                  # border_bottom
                  # border_left
                  target
                  title
                  type_of_menu
                  url
                }
              }
            }
          }
        }
      }
    }
    strapiProductSearch(id: { eq: $id }) {
      id
      slug
      title
      seo {
        ...seoFragment
      }
      topBanner {
        bigHeader
        ctaBtnLink
        ctaBtnText
        description
        topbanner: image {
          localFile {
            childImageSharp {
              gatsbyImageData(width: 575, placeholder: BLURRED, formats: PNG)
            }
          }
        }
        title
      }
      dynamicZoneComponents {
        ... on STRAPI__COMPONENT_COMMON_TIMELINE {
          ...timeLineFragment
        }
        ... on STRAPI__COMPONENT_COMMON_THREE_POINT_HIGHLIGHTER {
          ...threePointFragment
        }
        ... on STRAPI__COMPONENT_CATEGORY_IMAGE_TEXT_BLOCK {
          id
          imgRight
          learnMoreText
          learnMoreLink
          strapi_component
          subTitle
          textColor
          title
          bgColor
          divColor
          textBlockImage: image {
            localFile {
              childImageSharp {
                gatsbyImageData(
                  height: 328
                  width: 508
                  placeholder: BLURRED
                  formats: WEBP
                )
              }
            }
          }
        }
        ... on STRAPI__COMPONENT_COMMON_TIMED_FEATURE_LIST {
          id
          title
          subTitle
          learnMoreLink
          learnMoreText
          strapi_component
          color
          bgColor
          progressEmptyColor
          progressFillColor
          timedFeatures {
            id
            order
            featureIcon
            featureTitle
            featureSubTitle
            featureImage {
              localFile {
                childImageSharp {
                  gatsbyImageData(placeholder: NONE, formats: WEBP)
                }
              }
            }
          }
        }
        ... on STRAPI__COMPONENT_COMMON_TILE_WRAPPER {
          id
          strapi_component
          title
          subTitle
          learnMoreLink
          tiles {
            id
            title
            subTitle
            icon
            color
          }
          variant
          bgColor
          # tileWrapperClassName
          # titleClassName
          tileWrapperImage: image {
            localFile {
              childImageSharp {
                gatsbyImageData(width: 584, height: 476, placeholder: NONE)
              }
            }
          }
        }
        ... on STRAPI__COMPONENT_COMMON_IMAGE_WRAPPER {
          id
          strapi_component
          title
          subTitle
          variant
          imgPosition
          divColor
          imageWrapper: image {
            localFile {
              childImageSharp {
                gatsbyImageData(
                  formats: WEBP
                  quality: 100
                  height: 483
                  # width: 800
                )
              }
            }
          }
          learnMoreLink
        }
        # ... on STRAPI__COMPONENT_COMMON_TESTIMONIAL_SLIDER {
        #   ...testimonialSliderFragment
        # }
        ... on STRAPI__COMPONENT_COMMON_LAST_SCROLL_CTA {
          ...lastScrollCtaFragment
        }
        ... on STRAPI__COMPONENT_COMMON_FEATURE_STATS {
          ...featureStatsFragment
          subTitle
        }
        ... on STRAPI__COMPONENT_COMMON_TREE_WITH_THREE_TILES {
          ...treeWithThreeTilesFragments
        }
        ... on STRAPI__COMPONENT_COMMON_FAQ {
          ...faqFragment
        }
        ... on STRAPI__COMPONENT_COMMON_STEPS {
          ...stepsFragment
        }
        ... on STRAPI__COMPONENT_COMMON_CARD_WRAPPER {
          ...cardWrapperFragment
          cards {
            cardImage: image {
              localFile {
                childImageSharp {
                  gatsbyImageData(width: 355, height: 235, quality: 100)
                }
              }
            }
          }
        }
      }
    }
  }
`;

export default ProductSearchPage;

export const Head: HeadFC<PageDataModel, PageContextModel> = ({
  data,
  location,
}) => {
  const { title, seo } = data?.strapiProductSearch ?? {};

  const pathname = location?.pathname;
  return <SEO title={title} pathname={pathname} {...(seo ?? {})} />;
};
